(function () {
    'use strict';

    angular
        .module('elogbooks.user.reports')
        .controller('UserReportsAutomatedOverviewController', UserReportsAutomatedOverviewController);

    UserReportsAutomatedOverviewController.$inject = [
        '$state',
        '$scope',
        '$httpParamSerializer',
        '$timeout',
        'moment',
        'apiClient',
        'automatedOverviewAvailableDatesResponse',
        'rootResourceResponse',
        'user'
    ];

    function UserReportsAutomatedOverviewController(
        $state,
        $scope,
        $httpParamSerializer,
        $timeout,
        moment,
        apiClient,
        automatedOverviewAvailableDatesResponse,
        rootResourceResponse,
        user
    ) {
        const vm = this;

        const availableDates = automatedOverviewAvailableDatesResponse.data;

        vm.exportLink = rootResourceResponse.getLink('automated-overview-export');
        vm.exportParams = {};

        vm.siteCountLink = rootResourceResponse.getLink('automated-overview-site-count');
        vm.siteCount = null;

        let siteCountTimer = null;
        let siteCountRequest = 0;

        // Leaving within the debounce window shouldn't send a count nobody reads.
        $scope.$on('$destroy', function () {
            $timeout.cancel(siteCountTimer);
            siteCountRequest++;
            sitePruneRequest++;
        });
        let filterKey = 0;
        let sitePruneRequest = 0;
        const lastIds = {};

        vm.yearModel = {
            response: null,
            items: [],
            link: null,
            selected: null,
            disabled: false,
            populateDisabled: true,
            onSelect: onYearSelect,
            onRemove: onYearRemove
        };

        vm.monthModel = {
            response: null,
            items: [],
            link: null,
            selected: null,
            onSelect: onPeriodChange,
            onRemove: onPeriodChange
        };

        // CAFM-2836: site filters. Core Client narrows the Site Group list and Region narrows the Site list
        // (one way only), and drops the Site Group / Site picks that fall outside the narrowed list.
        // Regions list every active Region, not only those of the user's sites.
        const baseLinks = {
            coreClients: rootResourceResponse.getLink('coreclients'),
            siteGroups: rootResourceResponse.getLink('sitegroups'),
            regions: rootResourceResponse.getLink('regions'),
            sites: user.getLink('sites')
        };

        vm.coreClientModel = createFilterModel(baseLinks.coreClients, 'coreclients', { active: 'yes' }, whenChanged('coreClientModel', onCoreClientChange));
        vm.siteGroupModel = createFilterModel(baseLinks.siteGroups, 'sitegroups', { active: 'yes' }, whenChanged('siteGroupModel', onFilterChange));
        vm.regionModel = createFilterModel(baseLinks.regions, 'regions', { active: true }, whenChanged('regionModel', onRegionChange));
        vm.siteModel = createFilterModel(baseLinks.sites, 'sites', { status: 'active' }, whenChanged('siteModel', onFilterChange));

        init();

        function init() {
            const years = Object.keys(availableDates).map(function (year) {
                return parseInt(year, 10);
            });

            vm.yearModel.items = years.map(function (year) {
                return { title: String(year), value: year };
            });

            vm.yearModel.disabled = years.length === 1;

            const defaultPair = getDefaultYearMonthPair(years);
            const defaultYear = defaultPair ? defaultPair.year : null;
            const defaultMonth = defaultPair ? defaultPair.month : null;

            vm.yearModel.selected = findItem(vm.yearModel.items, defaultYear);

            populateMonthsForYear(defaultYear, false);

            vm.monthModel.selected = findItem(vm.monthModel.items, defaultMonth);
            updateExportParams();
            refreshSiteCount();
        }

        function getDefaultYearMonthPair(years) {
            const now = moment();
            const targetYear = now.year();
            const targetMonth = now.month() + 1;

            let defaultPair = null;
            let lastPair = null;

            years.forEach(function (year) {
                (availableDates[year] || []).forEach(function (month) {
                    const pair = { year: year, month: month };
                    lastPair = pair;

                    if (year < targetYear || (year === targetYear && month <= targetMonth)) {
                        defaultPair = pair;
                    }
                });
            });

            return defaultPair || lastPair;
        }

        function findItem(items, value) {
            return items.find(function (item) {
                return item.value === value;
            }) || null;
        }

        function populateMonthsForYear(year, clearSelection) {
            const months = (year !== null && availableDates[year]) ? availableDates[year] : [];

            vm.monthModel.items = months.map(function (month) {
                return {
                    title: moment().month(month - 1).format('MMMM'),
                    value: month,
                    id: month
                };
            });

            if (clearSelection) {
                vm.monthModel.selected = null;
            }
        }

        function onYearSelect() {
            const selectedYear = vm.yearModel.selected ? vm.yearModel.selected.value : null;
            populateMonthsForYear(selectedYear, true);
            onPeriodChange();
        }

        function onYearRemove() {
            vm.monthModel.items = [];
            vm.monthModel.selected = null;
            onPeriodChange();
        }

        // CAFM-2847: the count only includes sites active in the selected month.
        function onPeriodChange() {
            updateExportParams();
            refreshSiteCount();
        }

        function updateExportParams() {
            vm.exportParams = angular.extend({
                year: vm.yearModel.selected ? vm.yearModel.selected.value : null,
                month: vm.monthModel.selected ? vm.monthModel.selected.id : null
            }, getSiteFilterParams());
        }

        function getSiteFilterParams() {
            return {
                'coreClients[]': selectedIds(vm.coreClientModel),
                'siteGroups[]': selectedIds(vm.siteGroupModel),
                'regions[]': selectedIds(vm.regionModel),
                'sites[]': selectedIds(vm.siteModel)
            };
        }

        function createFilterModel(link, responseKeyPath, linkParameters, onChange, selectedItems) {
            return {
                key: ++filterKey,
                link: link,
                linkParameters: angular.extend({ order: 'name' }, linkParameters),
                responseKeyPath: responseKeyPath,
                itemValuePath: 'name',
                itemHrefPath: 'id',
                selectedItems: selectedItems || [],
                autocompletemulti: true,
                // The directive's init() already fetches the link, so its first search('') needn't refetch.
                cacheKeyword: '',
                onSelect: onChange,
                onRemove: onChange
            };
        }

        function selectedIds(model) {
            return model.selectedItems.map(function (item) {
                return item.href;
            });
        }

        // The parent selection goes in the child list's link, and a new link rebuilds that dropdown (see setLink).
        function linkWith(baseLink, paramName, ids) {
            if (!baseLink || ids.length === 0) {
                return baseLink;
            }

            const params = {};
            params[paramName] = ids;

            return baseLink + (baseLink.indexOf('?') === -1 ? '?' : '&') + $httpParamSerializer(params);
        }

        // A new model gets a new key, and the template re-creates the dropdown per key, so the fresh
        // directive fetches the new link once with clean items/response and the carried picks.
        function setLink(name, link) {
            const model = vm[name];

            if (model.link === link) {
                return;
            }

            vm[name] = createFilterModel(link, model.responseKeyPath, model.linkParameters, model.onSelect,
                model.selectedItems.slice());
            lastIds[name] = selectedIds(vm[name]).join();
        }

        function refreshLinks() {
            setLink('siteGroupModel', linkWith(baseLinks.siteGroups, 'coreClients[]', selectedIds(vm.coreClientModel)));
            setLink('siteModel', linkWith(baseLinks.sites, 'siteRegions[]', selectedIds(vm.regionModel)));
        }

        // The directive also calls onSelect when it is created, so act only when the picks really changed.
        function whenChanged(name, onChange) {
            lastIds[name] = '';

            return function (model) {
                const ids = selectedIds(model).join();

                if (ids !== lastIds[name]) {
                    lastIds[name] = ids;
                    onChange();
                }
            };
        }

        // Site Group list items embed their Core Client, so the picks can be checked here.
        function onCoreClientChange() {
            const coreClientIds = selectedIds(vm.coreClientModel);

            if (coreClientIds.length) {
                vm.siteGroupModel.selectedItems = vm.siteGroupModel.selectedItems.filter(function (item) {
                    const coreClient = item.object && item.object.coreClient;

                    return coreClient ? coreClientIds.indexOf(coreClient.id) !== -1 : false;
                });
                lastIds.siteGroupModel = selectedIds(vm.siteGroupModel).join();
            }

            onFilterChange();
        }

        // Site list items don't carry their Region, so ask the narrowed list which picks it still holds.
        function onRegionChange() {
            const regionIds = selectedIds(vm.regionModel);
            const siteIds = selectedIds(vm.siteModel);
            const requestId = ++sitePruneRequest;

            onFilterChange();

            if (!regionIds.length || !siteIds.length) {
                return;
            }

            apiClient.get(baseLinks.sites, {
                'siteRegions[]': regionIds,
                'siteIds[]': siteIds,
                limit: siteIds.length
            }, false).then(function (response) {
                // Ignore answers to superseded Region selections.
                if (requestId !== sitePruneRequest || !response) {
                    return;
                }

                const keptIds = (response.getData().sites || []).map(function (site) {
                    return site.id;
                });

                // Only drop what was checked: a Site picked while the request was out stays.
                vm.siteModel.selectedItems = vm.siteModel.selectedItems.filter(function (item) {
                    return siteIds.indexOf(item.href) === -1 || keptIds.indexOf(item.href) !== -1;
                });
                lastIds.siteModel = selectedIds(vm.siteModel).join();

                updateExportParams();
                refreshSiteCount();
            });
        }

        function onFilterChange() {
            refreshLinks();
            updateExportParams();
            refreshSiteCount();
        }

        function refreshSiteCount() {
            if (!vm.siteCountLink) {
                return;
            }

            if (siteCountTimer) {
                $timeout.cancel(siteCountTimer);
            }

            siteCountTimer = $timeout(function () {
                // Rebuild from the settled selection: the elb-autocomplete-multi max watch trims
                // selectedItems beyond max without calling onSelect/onRemove, so exportParams could
                // otherwise still carry an id the count no longer counts (or vice versa).
                // exportParams also carries year/month, which the count applies (CAFM-2847).
                updateExportParams();

                const requestId = ++siteCountRequest;

                apiClient.get(vm.siteCountLink, vm.exportParams, false).then(function (response) {
                    // Ignore answers to superseded selections.
                    if (requestId === siteCountRequest) {
                        vm.siteCount = response ? response.count : null;
                    }
                });
            }, 300);
        }
    }
})();